import { Box, Text } from "@prismicio/editor-ui"

import { SlicePreview } from "../slicePreview"
import type { VisualSharedSlice } from "../sliceTableData"
import { AiPrompt } from "./AiPrompt"

interface Props {
  slice: VisualSharedSlice
  disabled: boolean
  status: "idle" | "refining" | "error"
  prompt: string
  setPrompt: (value: string) => void
  refine: () => void
}

export function SelectedVersion(props: Props) {
  const { disabled, status, prompt, setPrompt, slice, refine } = props

  return (
    <>
      <Box flexDirection="column" gap={2}>
        <AiPrompt
          disabled={disabled}
          loading={status === "refining"}
          placeholder="Describe your changes..."
          value={prompt}
          onValueChange={setPrompt}
          onSend={refine}
        />
        <Text
          noSelect
          variant="small"
          color="tomato11"
          align="end"
          sx={{
            visibility: status === "error" ? "visible" : "hidden",
          }}
        >
          Something went wrong. Please, try again.
        </Text>
      </Box>
      <Box flexDirection="column" border borderRadius={6} padding={8}>
        <SlicePreview slice={slice} />
      </Box>
    </>
  )
}
